import { Auth, Logger } from 'aws-amplify';

const logger = new Logger('KeepAlive');

let keepAliveInterval = null;
let timeRemainingInterval = null;

let lastTokenExpirationSeconds = 0;

const doRefresh = () => {
    Auth.currentAuthenticatedUser().then(user => {
        logger.debug('refreshing Cognito session for user: ', user);
        user.refreshSession(user.signInUserSession.refreshToken, () => {
            logger.info('refreshed Cognito session @ ', new Date());
        });
    }).catch(err => {
        logger.error('failed to refresh Cognito session @ ', new Date());
        logger.debug(err);
    });
};

const doTimeRemainingCheck = (callback) => {
    const d = new Date();
    const epochSeconds = Math.round(d.getTime() / 1000);

    // only bother examining token once, or when session is about to expire
    if(lastTokenExpirationSeconds-epochSeconds<300) {
      Auth.currentSession().then(data => {
          logger.debug('checking remaining session time against access token: ', data);
          let secondsRemaining=0;
          if(data && data.accessToken && data.accessToken.payload) {
              const tokenExpirationSeconds = data.accessToken.payload.exp;
              secondsRemaining=tokenExpirationSeconds-epochSeconds;
              lastTokenExpirationSeconds=tokenExpirationSeconds;
              if (secondsRemaining>0) {
                  logger.debug(`${secondsRemaining} second(s) remaining on access token`);
              }
          }
          if(callback) {
              callback(Math.max(0,secondsRemaining));
          }
      }).catch(err => {
          logger.error('failed time remaining check @ ', new Date());
          logger.debug(err);
          if(callback) {
              callback(-1);
          }
      });
    }
    // else {
    //   logger.debug(`${lastTokenExpirationSeconds-epochSeconds} second(s) remaining on access token`);
    // }
};

export const startKeepAlive = (minutes = 30) => {

  // if (keepAliveInterval) {
  //   clearInterval(keepAliveInterval);
  // }

  if (!keepAliveInterval) {
    logger.info(`starting ${minutes} minute session refresh @ ${new Date()}`);
  
    keepAliveInterval = setInterval(() => {
      doRefresh();
    }, minutes * 60 * 1000);
  }
  
};

export const startTimeRemaining = (callback, seconds = 30) => {

  // if (timeRemainingInterval) {
  //   clearInterval(timeRemainingInterval);
  // }
  
  if (!timeRemainingInterval) {
    logger.info(`starting ${seconds} second time remaining check @ ${new Date()}`);
  
    timeRemainingInterval = setInterval(() => {
      doTimeRemainingCheck(callback);
    }, seconds * 1000);
  }
};
